// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Cta-cls1__de794d277a84e18eeb66{/*!*/}.Cta-cls2___0f2a9ae7fe53ee5811a{display:flex;align-items:center;flex-wrap:nowrap;grid-gap:8px;gap:8px;margin-left:-8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Cta-cls1__de794d277a84e18eeb66",
	"cls2": "Cta-cls2___0f2a9ae7fe53ee5811a Cta-cls1__de794d277a84e18eeb66"
};
export default ___CSS_LOADER_EXPORT___;
